/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Entry
 */
export interface Entry {
    /**
     * 
     * @type {string}
     * @memberof Entry
     */
    relationshipId?: string;
    /**
     * 
     * @type {string}
     * @memberof Entry
     */
    entryStart?: string;
}

/**
 * Check if a given object implements the Entry interface.
 */
export function instanceOfEntry(value: object): value is Entry {
    return true;
}

export function EntryFromJSON(json: any): Entry {
    return EntryFromJSONTyped(json, false);
}

export function EntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Entry {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'] == null ? undefined : json['relationshipId'],
        'entryStart': json['entryStart'] == null ? undefined : json['entryStart'],
    };
}

export function EntryToJSON(json: any): Entry {
    return EntryToJSONTyped(json, false);
}

export function EntryToJSONTyped(value?: Entry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'entryStart': value['entryStart'],
    };
}

